

import axiosInstance from "../lib/axios";


interface GetCategoryRequest {
  page?: number;
  limit?: number;
}

export const getCategories = async ({
  page = 1,
  limit = 10,
}: GetCategoryRequest) => {
  const body = {
    page,
    limit,
  };

  const { data } = await axiosInstance.post("/Category/List", body);

  return data;
};